/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseSector } from '../models/BaseSector';
import type { BaseTask } from '../models/BaseTask';
import type { Body_upload_declaration_file_latest_fsp_declarations_declaration__declaration_id__file_put } from '../models/Body_upload_declaration_file_latest_fsp_declarations_declaration__declaration_id__file_put';
import type { Body_upload_declaration_file_v1_fsp_declarations_declaration__declaration_id__file_put } from '../models/Body_upload_declaration_file_v1_fsp_declarations_declaration__declaration_id__file_put';
import type { DeclarationEditSchema } from '../models/DeclarationEditSchema';
import type { DeclarationInSchema } from '../models/DeclarationInSchema';
import type { DeclarationListOutSchema } from '../models/DeclarationListOutSchema';
import type { DeclarationOutSchema } from '../models/DeclarationOutSchema';
import type { EditShiftTimes } from '../models/EditShiftTimes';
import type { EnumDeclarationReviewStatus } from '../models/EnumDeclarationReviewStatus';
import type { FileUploadBase64 } from '../models/FileUploadBase64';
import type { SalaryTypeEnum } from '../models/SalaryTypeEnum';
import type { ShiftIn } from '../models/ShiftIn';
import type { SimpleShift } from '../models/SimpleShift';
import type { SimpleShiftWithAddedStatus } from '../models/SimpleShiftWithAddedStatus';
import type { SimpleShiftWithEditReason } from '../models/SimpleShiftWithEditReason';
import type { SimpleShiftWithRemovedStatus } from '../models/SimpleShiftWithRemovedStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FspService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get Declarations
   * ### Get Declarations
   *
   * Retrieve all declarations.
   *
   * **Permissions Required**:
   * `permission:can_manage_declarations`
   *
   * **Parameters**:
   * - Optional **declaration_status**: `EnumDeclarationReviewStatus` object to filter declarations by status, default: None.
   * - Optional **limit**: `int` object to limit the number of declarations returned, default: 100.
   * - Optional **offset**: `int` object to offset the number of declarations returned, default: 0.
   *
   * **Returns**:
   * - ListSchema: List of declarations with metadata.
   *
   * ** Future Improvements **:
   * - Add ordering to parameters
   * @param declarationStatus
   * @param limit
   * @param offset
   * @returns DeclarationListOutSchema Successful Response
   * @throws ApiError
   */
  public getFspGetDeclarations(
    declarationStatus?: EnumDeclarationReviewStatus | null,
    limit?: number | null,
    offset?: number | null
  ): CancelablePromise<DeclarationListOutSchema> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/fsp/declarations/declarations',
      query: {
        declaration_status: declarationStatus,
        limit: limit,
        offset: offset,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Coach Declarations
   * ### Get Coach Declarations
   *
   * Retrieve all declarations associated with a specific coach.
   *
   * **Permissions Required**:
   * `view_coach_declarations`
   * ***found in:***
   * - `permission:can_manage_declarations`
   * - `User` == matching `Coach`
   *
   * **Parameters**:
   * - **coach**: `Coach` object, fetched by the path parameter.
   * - Optional **declaration_status**: `EnumDeclarationReviewStatus` object to filter declarations by status.
   * - Optional **limit**: `int` object to limit the number of declarations returned.
   * - Optional **offset**: `int` object to offset the number of declarations returned.
   *
   * **Returns**:
   * - `List[DeclarationOutSchema]`: List of declarations for the specified coach.
   * @param coachId
   * @param declarationStatus
   * @param limit
   * @param offset
   * @returns DeclarationListOutSchema Successful Response
   * @throws ApiError
   */
  public getFspGetCoachDeclarations(
    coachId: number,
    declarationStatus?: EnumDeclarationReviewStatus | null,
    limit?: number | null,
    offset?: number | null
  ): CancelablePromise<DeclarationListOutSchema> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/fsp/declarations/{coach_id}/declarations',
      path: {
        coach_id: coachId,
      },
      query: {
        declaration_status: declarationStatus,
        limit: limit,
        offset: offset,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Coach Declaration
   * ### Create Coach Declaration
   *
   * Create a new declaration for a specific coach.
   *
   * **Permissions Required**:
   * `create_declaration`
   * ***found in:***
   * - `permission:can_manage_declarations`
   * - `User` == matching `Coach`
   *
   * **Parameters**:
   * - **declaration_in**: `DeclarationInSchema` object containing the declaration details.
   * - **coach**: `Coach` object, fetched by the path parameter.
   *
   * **Returns**:
   * - `DeclarationOutSchema`: The created declaration object.
   * @param coachId
   * @param requestBody
   * @returns DeclarationOutSchema Successful Response
   * @throws ApiError
   */
  public postFspCreateCoachDeclaration(
    coachId: number,
    requestBody: DeclarationInSchema
  ): CancelablePromise<DeclarationOutSchema> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/fsp/declarations/{coach_id}/declaration',
      path: {
        coach_id: coachId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Upload Declaration File
   * ### Upload Declaration File
   *
   * Upload a file for a specific declaration.
   *
   * **Permissions Required**:
   * `DeclarationPermission.EDIT`
   * ***found in:***
   * - `permission:can_manage_declarations`
   * - `User` == matching `Coach`
   *
   * **Parameters**:
   * - **declaration**: `Declaration` object, fetched by path parameter.
   * - **file**: `UploadFile` object containing the file to upload.
   *
   * **Returns**:
   * - `DeclarationOutSchema`: The updated declaration object.
   *
   * **Exceptions**:
   * - Raises a 400 error if the file size is too large. (default max size is 10MB)
   * - Raises a 400 error if the file type is not allowed. (only PDF, Word, and images are allowed)
   * - Raises a 400 error if the file upload fails.
   * @param declarationId
   * @param formData
   * @returns DeclarationOutSchema Successful Response
   * @throws ApiError
   */
  public putFspUploadDeclarationFile(
    declarationId: number,
    formData: Body_upload_declaration_file_v1_fsp_declarations_declaration__declaration_id__file_put
  ): CancelablePromise<DeclarationOutSchema> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/v1/fsp/declarations/declaration/{declaration_id}/file',
      path: {
        declaration_id: declarationId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Upload Declaration File Base64
   * ### Upload Declaration File
   *
   * Upload a file for a specific declaration.
   *
   * **Permissions Required**:
   * `DeclarationPermission.EDIT`
   * ***found in:***
   * - `permission:can_manage_declarations`
   * __OR__
   * - `User` == matching `Coach`
   *
   * **Parameters**:
   * - **declaration**: `Declaration` object, fetched by path parameter.
   * - BODY element is the file encoded in base64.
   *
   * **Returns**:
   * - `DeclarationOutSchema`: The updated declaration object.
   *
   * **Exceptions**:
   * - Raises a 400 error if the file size is too large. (default max size is 10MB)
   * - Raises a 400 error if the file type is not allowed. (only PDF, Word, images are allowed)
   * - Raises a 400 error if the file upload fails.
   *
   * `!!!` The mime type extractions is still experimental, so if any expected allowed mime_type is rejected, report the issue`!!!`
   *
   * `!!!` __This endpoint is not in working condition via SwaggerUI, but works via the generated react-native api in the apps.__ `!!!`
   * @param declarationId
   * @param requestBody
   * @returns DeclarationOutSchema Successful Response
   * @throws ApiError
   */
  public putFspUploadDeclarationFileBase64(
    declarationId: number,
    requestBody: FileUploadBase64
  ): CancelablePromise<DeclarationOutSchema> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/v1/fsp/declarations/declaration/{declaration_id}/file_base64',
      path: {
        declaration_id: declarationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Declaration
   * ### Delete Declaration
   *
   * Delete a specific declaration.
   *
   * **Permissions Required**:
   * `DeclarationPermission.DELETE`
   * ***found in:***
   * - `permission:can_manage_declarations`
   * - `User` == matching `Coach`
   *
   * **Parameters**:
   * - **declaration**: `Declaration` object, fetched by path parameter.
   *
   * **Returns**:
   * - `dict`: Message confirming deletion of the declaration.
   * @param declarationId
   * @returns any Successful Response
   * @throws ApiError
   */
  public deleteFspDeleteDeclaration(declarationId: number): CancelablePromise<Record<string, any>> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/v1/fsp/declarations/declaration/{declaration_id}',
      path: {
        declaration_id: declarationId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Review Declaration
   * ### Review Declaration
   *
   * Update the review status of a specific declaration.
   *
   * **Permissions Required**:
   * `DeclarationPermission.REVIEW`
   * ***found in:***
   * - `permission:can_manage_declarations`
   *
   * **Parameters**:
   * - **updated_at**: `datetime` object to check if the declaration has been updated by another user.
   * - **review_status**: `EnumDeclarationReviewStatus` object for the new review status.
   * - **declaration**: `Declaration` object, fetched by path parameter.
   *
   * **Returns**:
   * - `DeclarationOutSchema`: The updated declaration with the new review status.
   * @param reviewStatus
   * @param declarationId
   * @param updatedAt
   * @returns DeclarationOutSchema Successful Response
   * @throws ApiError
   */
  public patchFspReviewDeclaration(
    reviewStatus: EnumDeclarationReviewStatus,
    declarationId: number,
    updatedAt: string
  ): CancelablePromise<DeclarationOutSchema> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/fsp/declarations/declaration/{declaration_id}/review/{review_status}',
      path: {
        review_status: reviewStatus,
        declaration_id: declarationId,
      },
      query: {
        updated_at: updatedAt,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Edit Declaration
   * ### Edit Declaration
   *
   * Edit an existing declaration.
   *
   * **Permissions Required**:
   * - permission:can_manage_declarations
   * -- OR --
   * - user == matching coach
   *
   * **Parameters**:
   * - **declaration_edit**: `DeclarationEditSchema` object containing updated declaration details.
   * - **declaration**: `Declaration` object, fetched by path parameter.
   *
   * **Returns**:
   * - `DeclarationOutSchema`: The edited declaration object.
   * @param declarationId
   * @param requestBody
   * @returns DeclarationOutSchema Successful Response
   * @throws ApiError
   */
  public patchFspEditDeclaration(
    declarationId: number,
    requestBody: DeclarationEditSchema
  ): CancelablePromise<DeclarationOutSchema> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/fsp/declarations/declaration/{declaration_id}/edit',
      path: {
        declaration_id: declarationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Edit Shift Worked Hours And Break Time
   * ### Edit shift times
   *
   * Edit the start- end- and break time of a shift.
   *
   * **Permissions Required**:
   * `edit_hours`
   * ***found in:***
   * - `permission:can_manage_shifts`
   * - `User` == matching `Shift`
   *
   * **Parameters**:
   * - **shift_id**: `int` object, fetched by the path parameter.
   * - **start_time**: `time` object to set the new start time.
   * - **end_time**: `time` object to set the new end time.
   * - **break_time**: `time` object to set the new break time.
   * - **edit_reason**: `str` object to provide a reason for the edit.
   *
   * **Returns**:
   * - `Shift`: The corrected shift.
   *
   * **Raises**:
   * - `422`: If the end_time is before the start_time.
   * - `400`: If the shift does not have a coach.
   * - `400`: If a coach tries to edit a shift that has not passed yet.
   * - `400`: If Office tries to edit a shift that is not in the current week without providing a reason.
   * -
   * @param shiftId
   * @param requestBody
   * @param editReason
   * @returns SimpleShiftWithEditReason Successful Response
   * @throws ApiError
   */
  public patchFspEditShiftWorkedHoursAndBreakTime(
    shiftId: number,
    requestBody: EditShiftTimes,
    editReason?: string | null
  ): CancelablePromise<SimpleShiftWithEditReason> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/fsp/shifts/shift/{shift_id}/edit/worked_hours',
      path: {
        shift_id: shiftId,
      },
      query: {
        edit_reason: editReason,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Remove Coach From Shift
   * ### Remove coach from shift
   *
   * Remove a coach from a shift.
   *
   * **Permissions Required**:
   * `edit_hours`
   * ***found in:***
   * - `permission:can_manage_shifts`
   * - `User` == matching `Shift`
   *
   * **Parameters**:
   * - **shift_id**: `int` object, fetched by the path parameter.
   *
   * **Returns**:
   * - `Shift`: The corrected shift.
   *
   * **Raises**:
   * - `400`: If the shift does not have a coach.
   * - `400`: If a coach tries to edit a shift that has not passed yet.
   * @param shiftId
   * @returns SimpleShiftWithRemovedStatus Successful Response
   * @throws ApiError
   */
  public patchFspRemoveCoachFromShift(
    shiftId: number
  ): CancelablePromise<SimpleShiftWithRemovedStatus> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/fsp/shifts/shift/{shift_id}/edit/accord/remove',
      path: {
        shift_id: shiftId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Coach Worked Sectors
   * ### Get worked sectors of a coach
   *
   * Get all sectors the coach has worked in.
   *
   * **Permissions Required**:
   * `view`
   * ***found in:***
   * - `permission:can_manage_jobs`
   * - `User` == matching `Shift`
   *
   * **Parameters**:
   * - **coach_id**: `int` object, fetched by the path parameter.
   *
   * **Returns**:
   * - `List[BaseSector]`: The sectors the coach has worked in.
   * @param coachId
   * @returns BaseSector Successful Response
   * @throws ApiError
   */
  public getFspGetCoachWorkedSectors(coachId: number): CancelablePromise<Array<BaseSector>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/fsp/shifts/coach/{coach_id}/worked_sectors',
      path: {
        coach_id: coachId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Shift To Accord
   * ### Add a shift to a coach,
   *
   * Add a coach to a shift.
   *
   * **Permissions Required**:
   * `edit_hours`
   * `view`
   * ***found in:***
   * - `permission:can_manage_jobs`
   * - `permission:can_manage_shifts`
   * - `User` == matching `Shift`
   *
   * **Parameters**:
   * - **shift_id**: `int` object, fetched by the path parameter.
   *
   * **Returns**:
   * - `Shift`: The corrected shift.
   *
   * **Raises**:
   * - `400`: If the coach has not yet worked at the selected branch, and the user is not from the office.
   * - `400`: If the shift-date is set on today/after today and the user is not from the office.
   * @param coachId
   * @param branchId
   * @param sectorId
   * @param requestBody
   * @returns SimpleShiftWithAddedStatus Successful Response
   * @throws ApiError
   */
  public postFspAddShiftToAccord(
    coachId: number,
    branchId: number,
    sectorId: number,
    requestBody: ShiftIn
  ): CancelablePromise<SimpleShiftWithAddedStatus> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/fsp/shifts/shift/edit/accord/add/branch/{branch_id}/sector/{sector_id}/coach/{coach_id}',
      path: {
        coach_id: coachId,
        branch_id: branchId,
        sector_id: sectorId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Accord Shifts
   * ### Create Accordation
   *
   * Accords all unaccorded shifts of a coach in the current week (from monday to sunday).
   *
   *
   * **Permissions Required**:
   * `accord_shifts`
   * @param coachId
   * @returns SimpleShift Successful Response
   * @throws ApiError
   */
  public patchFspAccordShifts(coachId: number): CancelablePromise<Array<SimpleShift>> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/fsp/accordation/{coach_id}/accordation',
      path: {
        coach_id: coachId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Coach Salary
   * ### Get Coach Salary
   *
   * Retrieve the salary of a coach.
   *
   * **Permissions Required**:
   * `view_coach_salary`
   * ***found in:***
   * - `permission:can_manage_coaches`
   * - `User` == matching `Coach`
   *
   * **Parameters**:
   * - **salary_type**: `SalaryTypeEnum` object, default is `BIJLES`.
   * - **coach_id**: `int` object, fetched by the path parameter.
   *
   * **Returns**:
   * - `float`: The salary of the coach
   * @param coachId
   * @param salaryType
   * @returns number Successful Response
   * @throws ApiError
   */
  public getFspGetCoachSalary(
    coachId: number,
    salaryType: SalaryTypeEnum
  ): CancelablePromise<number> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/fsp/fsp_coach/coach/{coach_id}/salary',
      path: {
        coach_id: coachId,
      },
      query: {
        salary_type: salaryType,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Edit Coach Salary
   * ### Edit Coach Salary
   *
   * Edit the salary of a coach.
   *
   * **Permissions Required**:
   * `edit_coach_salary`
   * ***found in:***
   * - `permission:can_manage_coaches`
   * - `User` == matching `Coach`
   *
   * **Parameters**:
   * - **coach_id**: `int` object, fetched by the path parameter.
   * - **salary**: `float` object, updated salary value.
   * - **salary_type**: `SalaryTypeEnum` object, default is `bijles`.
   *
   * **Returns**:
   * - `float`: The updated salary of the coach
   * @param coachId
   * @param salary
   * @param salaryType
   * @returns number Successful Response
   * @throws ApiError
   */
  public patchFspEditCoachSalary(
    coachId: number,
    salary: number,
    salaryType: SalaryTypeEnum
  ): CancelablePromise<number> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/fsp/fsp_coach/coach/{coach_id}/salary',
      path: {
        coach_id: coachId,
      },
      query: {
        salary: salary,
        salary_type: salaryType,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Set Coach Branch Distance
   * ### Set the distance between a coach and a branch, if it does not yet exist
   * Args:
   * - coach_id: int: the id of the coach
   * - branch_id: int: the id of the branch
   * - distance: float: the distance between the coach and the branch
   * Returns:
   * - The added UserLocationDistance object
   *
   * NOTE: This endpoint gets the userlocation that is denoted in their personal information.
   *
   * This means that if a coach has multiple locations, we look for the location in which the zipcode matches that of their personal information.
   * @param coachId
   * @param branchId
   * @param distance
   * @returns any Successful Response
   * @throws ApiError
   */
  public postFspSetCoachBranchDistance(
    coachId: number,
    branchId: number,
    distance: number
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/fsp/fsp_coach/coach/{coach_id}/branch/{branch_id}/distance',
      path: {
        coach_id: coachId,
        branch_id: branchId,
      },
      query: {
        distance: distance,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Build Facturation Csv
   * ### Start constructing the facturation csv
   *
   * Get the facturation csv for the last week. This is all shifts that have been accorded in the previous week.
   *
   * Args:
   * - week (int): The week number of the week to get the facturation csv for, defaults to the previous week
   * - year (int): The year of the week to get the facturation csv for, defaults to the current year
   *
   * Important to note:
   * - The function is expected to be called only by people from the office, on monday around 9:00
   *
   * Returns:
   * - The csv with all shifts that have been accorded in the previous week, that have to be facturated from collaborations: "'Te factureren: samenwerkingspartners'"
   * @param week
   * @param year
   * @returns BaseTask Successful Response
   * @throws ApiError
   */
  public postFspBuildFacturationCsv(
    week: number = 10,
    year: number = 2025
  ): CancelablePromise<BaseTask> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/fsp/facturation/facturation/csv/collaborations/week',
      query: {
        week: week,
        year: year,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Build Facturation Csv Month
   * ### Start constructing the facturation csv
   *
   * Get the facturation csv for the last month. This is all shifts that have been accorded in the previous month.
   *
   * Args:
   * - month (int): The month number of the month to get the facturation csv for, defaults to the previous month
   * - year (int): The year of the month to get the facturation csv for, defaults to the current year
   *
   * Returns:
   * - The csv with all shifts that have been accorded in the previous month, that have to be facturated from coaches: "'Uit te betalen: Studyworkers'"
   * @param month
   * @param year
   * @returns BaseTask Successful Response
   * @throws ApiError
   */
  public postFspBuildFacturationCsvMonth(
    month: number = 2,
    year: number = 2025
  ): CancelablePromise<BaseTask> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/fsp/facturation/facturation/csv/coaches/month',
      query: {
        month: month,
        year: year,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Collaboration Facturation Csv String Task
   * ### Get facturation csv task
   *
   * This endpoint gets the task status of the facturation csv task. If the task is successful, it will return the csv as a response.
   *
   * This is used for both the weekly and monthly facturation csv tasks.
   * - Weekly: "'Te factureren: samenwerkingspartners'"
   * - Monthly: "'Uit te betalen: Studyworkers'"
   *
   * Args:
   * - task_id (str): The task id of the facturation csv task
   *
   * Returns:
   * - The task status of the facturation csv task
   * @param taskId
   * @returns any Successful Response
   * @throws ApiError
   */
  public getFspGetCollaborationFacturationCsvStringTask(taskId: string): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/fsp/facturation/facturation/csv/task/{task_id}',
      path: {
        task_id: taskId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Declarations
   * ### Get Declarations
   *
   * Retrieve all declarations.
   *
   * **Permissions Required**:
   * `permission:can_manage_declarations`
   *
   * **Parameters**:
   * - Optional **declaration_status**: `EnumDeclarationReviewStatus` object to filter declarations by status, default: None.
   * - Optional **limit**: `int` object to limit the number of declarations returned, default: 100.
   * - Optional **offset**: `int` object to offset the number of declarations returned, default: 0.
   *
   * **Returns**:
   * - ListSchema: List of declarations with metadata.
   *
   * ** Future Improvements **:
   * - Add ordering to parameters
   * @param declarationStatus
   * @param limit
   * @param offset
   * @returns DeclarationListOutSchema Successful Response
   * @throws ApiError
   */
  public getFspGetDeclarationsVLatest(
    declarationStatus?: EnumDeclarationReviewStatus | null,
    limit?: number | null,
    offset?: number | null
  ): CancelablePromise<DeclarationListOutSchema> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/fsp/declarations/declarations',
      query: {
        declaration_status: declarationStatus,
        limit: limit,
        offset: offset,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Coach Declarations
   * ### Get Coach Declarations
   *
   * Retrieve all declarations associated with a specific coach.
   *
   * **Permissions Required**:
   * `view_coach_declarations`
   * ***found in:***
   * - `permission:can_manage_declarations`
   * - `User` == matching `Coach`
   *
   * **Parameters**:
   * - **coach**: `Coach` object, fetched by the path parameter.
   * - Optional **declaration_status**: `EnumDeclarationReviewStatus` object to filter declarations by status.
   * - Optional **limit**: `int` object to limit the number of declarations returned.
   * - Optional **offset**: `int` object to offset the number of declarations returned.
   *
   * **Returns**:
   * - `List[DeclarationOutSchema]`: List of declarations for the specified coach.
   * @param coachId
   * @param declarationStatus
   * @param limit
   * @param offset
   * @returns DeclarationListOutSchema Successful Response
   * @throws ApiError
   */
  public getFspGetCoachDeclarationsVLatest(
    coachId: number,
    declarationStatus?: EnumDeclarationReviewStatus | null,
    limit?: number | null,
    offset?: number | null
  ): CancelablePromise<DeclarationListOutSchema> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/fsp/declarations/{coach_id}/declarations',
      path: {
        coach_id: coachId,
      },
      query: {
        declaration_status: declarationStatus,
        limit: limit,
        offset: offset,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Coach Declaration
   * ### Create Coach Declaration
   *
   * Create a new declaration for a specific coach.
   *
   * **Permissions Required**:
   * `create_declaration`
   * ***found in:***
   * - `permission:can_manage_declarations`
   * - `User` == matching `Coach`
   *
   * **Parameters**:
   * - **declaration_in**: `DeclarationInSchema` object containing the declaration details.
   * - **coach**: `Coach` object, fetched by the path parameter.
   *
   * **Returns**:
   * - `DeclarationOutSchema`: The created declaration object.
   * @param coachId
   * @param requestBody
   * @returns DeclarationOutSchema Successful Response
   * @throws ApiError
   */
  public postFspCreateCoachDeclarationVLatest(
    coachId: number,
    requestBody: DeclarationInSchema
  ): CancelablePromise<DeclarationOutSchema> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/fsp/declarations/{coach_id}/declaration',
      path: {
        coach_id: coachId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Upload Declaration File
   * ### Upload Declaration File
   *
   * Upload a file for a specific declaration.
   *
   * **Permissions Required**:
   * `DeclarationPermission.EDIT`
   * ***found in:***
   * - `permission:can_manage_declarations`
   * - `User` == matching `Coach`
   *
   * **Parameters**:
   * - **declaration**: `Declaration` object, fetched by path parameter.
   * - **file**: `UploadFile` object containing the file to upload.
   *
   * **Returns**:
   * - `DeclarationOutSchema`: The updated declaration object.
   *
   * **Exceptions**:
   * - Raises a 400 error if the file size is too large. (default max size is 10MB)
   * - Raises a 400 error if the file type is not allowed. (only PDF, Word, and images are allowed)
   * - Raises a 400 error if the file upload fails.
   * @param declarationId
   * @param formData
   * @returns DeclarationOutSchema Successful Response
   * @throws ApiError
   */
  public putFspUploadDeclarationFileVLatest(
    declarationId: number,
    formData: Body_upload_declaration_file_latest_fsp_declarations_declaration__declaration_id__file_put
  ): CancelablePromise<DeclarationOutSchema> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/latest/fsp/declarations/declaration/{declaration_id}/file',
      path: {
        declaration_id: declarationId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Upload Declaration File Base64
   * ### Upload Declaration File
   *
   * Upload a file for a specific declaration.
   *
   * **Permissions Required**:
   * `DeclarationPermission.EDIT`
   * ***found in:***
   * - `permission:can_manage_declarations`
   * __OR__
   * - `User` == matching `Coach`
   *
   * **Parameters**:
   * - **declaration**: `Declaration` object, fetched by path parameter.
   * - BODY element is the file encoded in base64.
   *
   * **Returns**:
   * - `DeclarationOutSchema`: The updated declaration object.
   *
   * **Exceptions**:
   * - Raises a 400 error if the file size is too large. (default max size is 10MB)
   * - Raises a 400 error if the file type is not allowed. (only PDF, Word, images are allowed)
   * - Raises a 400 error if the file upload fails.
   *
   * `!!!` The mime type extractions is still experimental, so if any expected allowed mime_type is rejected, report the issue`!!!`
   *
   * `!!!` __This endpoint is not in working condition via SwaggerUI, but works via the generated react-native api in the apps.__ `!!!`
   * @param declarationId
   * @param requestBody
   * @returns DeclarationOutSchema Successful Response
   * @throws ApiError
   */
  public putFspUploadDeclarationFileBase64VLatest(
    declarationId: number,
    requestBody: FileUploadBase64
  ): CancelablePromise<DeclarationOutSchema> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/latest/fsp/declarations/declaration/{declaration_id}/file_base64',
      path: {
        declaration_id: declarationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Declaration
   * ### Delete Declaration
   *
   * Delete a specific declaration.
   *
   * **Permissions Required**:
   * `DeclarationPermission.DELETE`
   * ***found in:***
   * - `permission:can_manage_declarations`
   * - `User` == matching `Coach`
   *
   * **Parameters**:
   * - **declaration**: `Declaration` object, fetched by path parameter.
   *
   * **Returns**:
   * - `dict`: Message confirming deletion of the declaration.
   * @param declarationId
   * @returns any Successful Response
   * @throws ApiError
   */
  public deleteFspDeleteDeclarationVLatest(
    declarationId: number
  ): CancelablePromise<Record<string, any>> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/latest/fsp/declarations/declaration/{declaration_id}',
      path: {
        declaration_id: declarationId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Review Declaration
   * ### Review Declaration
   *
   * Update the review status of a specific declaration.
   *
   * **Permissions Required**:
   * `DeclarationPermission.REVIEW`
   * ***found in:***
   * - `permission:can_manage_declarations`
   *
   * **Parameters**:
   * - **updated_at**: `datetime` object to check if the declaration has been updated by another user.
   * - **review_status**: `EnumDeclarationReviewStatus` object for the new review status.
   * - **declaration**: `Declaration` object, fetched by path parameter.
   *
   * **Returns**:
   * - `DeclarationOutSchema`: The updated declaration with the new review status.
   * @param reviewStatus
   * @param declarationId
   * @param updatedAt
   * @returns DeclarationOutSchema Successful Response
   * @throws ApiError
   */
  public patchFspReviewDeclarationVLatest(
    reviewStatus: EnumDeclarationReviewStatus,
    declarationId: number,
    updatedAt: string
  ): CancelablePromise<DeclarationOutSchema> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/latest/fsp/declarations/declaration/{declaration_id}/review/{review_status}',
      path: {
        review_status: reviewStatus,
        declaration_id: declarationId,
      },
      query: {
        updated_at: updatedAt,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Edit Declaration
   * ### Edit Declaration
   *
   * Edit an existing declaration.
   *
   * **Permissions Required**:
   * - permission:can_manage_declarations
   * -- OR --
   * - user == matching coach
   *
   * **Parameters**:
   * - **declaration_edit**: `DeclarationEditSchema` object containing updated declaration details.
   * - **declaration**: `Declaration` object, fetched by path parameter.
   *
   * **Returns**:
   * - `DeclarationOutSchema`: The edited declaration object.
   * @param declarationId
   * @param requestBody
   * @returns DeclarationOutSchema Successful Response
   * @throws ApiError
   */
  public patchFspEditDeclarationVLatest(
    declarationId: number,
    requestBody: DeclarationEditSchema
  ): CancelablePromise<DeclarationOutSchema> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/latest/fsp/declarations/declaration/{declaration_id}/edit',
      path: {
        declaration_id: declarationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Edit Shift Worked Hours And Break Time
   * ### Edit shift times
   *
   * Edit the start- end- and break time of a shift.
   *
   * **Permissions Required**:
   * `edit_hours`
   * ***found in:***
   * - `permission:can_manage_shifts`
   * - `User` == matching `Shift`
   *
   * **Parameters**:
   * - **shift_id**: `int` object, fetched by the path parameter.
   * - **start_time**: `time` object to set the new start time.
   * - **end_time**: `time` object to set the new end time.
   * - **break_time**: `time` object to set the new break time.
   * - **edit_reason**: `str` object to provide a reason for the edit.
   *
   * **Returns**:
   * - `Shift`: The corrected shift.
   *
   * **Raises**:
   * - `422`: If the end_time is before the start_time.
   * - `400`: If the shift does not have a coach.
   * - `400`: If a coach tries to edit a shift that has not passed yet.
   * - `400`: If Office tries to edit a shift that is not in the current week without providing a reason.
   * -
   * @param shiftId
   * @param requestBody
   * @param editReason
   * @returns SimpleShiftWithEditReason Successful Response
   * @throws ApiError
   */
  public patchFspEditShiftWorkedHoursAndBreakTimeVLatest(
    shiftId: number,
    requestBody: EditShiftTimes,
    editReason?: string | null
  ): CancelablePromise<SimpleShiftWithEditReason> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/latest/fsp/shifts/shift/{shift_id}/edit/worked_hours',
      path: {
        shift_id: shiftId,
      },
      query: {
        edit_reason: editReason,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Remove Coach From Shift
   * ### Remove coach from shift
   *
   * Remove a coach from a shift.
   *
   * **Permissions Required**:
   * `edit_hours`
   * ***found in:***
   * - `permission:can_manage_shifts`
   * - `User` == matching `Shift`
   *
   * **Parameters**:
   * - **shift_id**: `int` object, fetched by the path parameter.
   *
   * **Returns**:
   * - `Shift`: The corrected shift.
   *
   * **Raises**:
   * - `400`: If the shift does not have a coach.
   * - `400`: If a coach tries to edit a shift that has not passed yet.
   * @param shiftId
   * @returns SimpleShiftWithRemovedStatus Successful Response
   * @throws ApiError
   */
  public patchFspRemoveCoachFromShiftVLatest(
    shiftId: number
  ): CancelablePromise<SimpleShiftWithRemovedStatus> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/latest/fsp/shifts/shift/{shift_id}/edit/accord/remove',
      path: {
        shift_id: shiftId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Coach Worked Sectors
   * ### Get worked sectors of a coach
   *
   * Get all sectors the coach has worked in.
   *
   * **Permissions Required**:
   * `view`
   * ***found in:***
   * - `permission:can_manage_jobs`
   * - `User` == matching `Shift`
   *
   * **Parameters**:
   * - **coach_id**: `int` object, fetched by the path parameter.
   *
   * **Returns**:
   * - `List[BaseSector]`: The sectors the coach has worked in.
   * @param coachId
   * @returns BaseSector Successful Response
   * @throws ApiError
   */
  public getFspGetCoachWorkedSectorsVLatest(coachId: number): CancelablePromise<Array<BaseSector>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/fsp/shifts/coach/{coach_id}/worked_sectors',
      path: {
        coach_id: coachId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Add Shift To Accord
   * ### Add a shift to a coach,
   *
   * Add a coach to a shift.
   *
   * **Permissions Required**:
   * `edit_hours`
   * `view`
   * ***found in:***
   * - `permission:can_manage_jobs`
   * - `permission:can_manage_shifts`
   * - `User` == matching `Shift`
   *
   * **Parameters**:
   * - **shift_id**: `int` object, fetched by the path parameter.
   *
   * **Returns**:
   * - `Shift`: The corrected shift.
   *
   * **Raises**:
   * - `400`: If the coach has not yet worked at the selected branch, and the user is not from the office.
   * - `400`: If the shift-date is set on today/after today and the user is not from the office.
   * @param coachId
   * @param branchId
   * @param sectorId
   * @param requestBody
   * @returns SimpleShiftWithAddedStatus Successful Response
   * @throws ApiError
   */
  public postFspAddShiftToAccordVLatest(
    coachId: number,
    branchId: number,
    sectorId: number,
    requestBody: ShiftIn
  ): CancelablePromise<SimpleShiftWithAddedStatus> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/fsp/shifts/shift/edit/accord/add/branch/{branch_id}/sector/{sector_id}/coach/{coach_id}',
      path: {
        coach_id: coachId,
        branch_id: branchId,
        sector_id: sectorId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Accord Shifts
   * ### Create Accordation
   *
   * Accords all unaccorded shifts of a coach in the current week (from monday to sunday).
   *
   *
   * **Permissions Required**:
   * `accord_shifts`
   * @param coachId
   * @returns SimpleShift Successful Response
   * @throws ApiError
   */
  public patchFspAccordShiftsVLatest(coachId: number): CancelablePromise<Array<SimpleShift>> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/latest/fsp/accordation/{coach_id}/accordation',
      path: {
        coach_id: coachId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Coach Salary
   * ### Get Coach Salary
   *
   * Retrieve the salary of a coach.
   *
   * **Permissions Required**:
   * `view_coach_salary`
   * ***found in:***
   * - `permission:can_manage_coaches`
   * - `User` == matching `Coach`
   *
   * **Parameters**:
   * - **salary_type**: `SalaryTypeEnum` object, default is `BIJLES`.
   * - **coach_id**: `int` object, fetched by the path parameter.
   *
   * **Returns**:
   * - `float`: The salary of the coach
   * @param coachId
   * @param salaryType
   * @returns number Successful Response
   * @throws ApiError
   */
  public getFspGetCoachSalaryVLatest(
    coachId: number,
    salaryType: SalaryTypeEnum
  ): CancelablePromise<number> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/fsp/fsp_coach/coach/{coach_id}/salary',
      path: {
        coach_id: coachId,
      },
      query: {
        salary_type: salaryType,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Edit Coach Salary
   * ### Edit Coach Salary
   *
   * Edit the salary of a coach.
   *
   * **Permissions Required**:
   * `edit_coach_salary`
   * ***found in:***
   * - `permission:can_manage_coaches`
   * - `User` == matching `Coach`
   *
   * **Parameters**:
   * - **coach_id**: `int` object, fetched by the path parameter.
   * - **salary**: `float` object, updated salary value.
   * - **salary_type**: `SalaryTypeEnum` object, default is `bijles`.
   *
   * **Returns**:
   * - `float`: The updated salary of the coach
   * @param coachId
   * @param salary
   * @param salaryType
   * @returns number Successful Response
   * @throws ApiError
   */
  public patchFspEditCoachSalaryVLatest(
    coachId: number,
    salary: number,
    salaryType: SalaryTypeEnum
  ): CancelablePromise<number> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/latest/fsp/fsp_coach/coach/{coach_id}/salary',
      path: {
        coach_id: coachId,
      },
      query: {
        salary: salary,
        salary_type: salaryType,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Set Coach Branch Distance
   * ### Set the distance between a coach and a branch, if it does not yet exist
   * Args:
   * - coach_id: int: the id of the coach
   * - branch_id: int: the id of the branch
   * - distance: float: the distance between the coach and the branch
   * Returns:
   * - The added UserLocationDistance object
   *
   * NOTE: This endpoint gets the userlocation that is denoted in their personal information.
   *
   * This means that if a coach has multiple locations, we look for the location in which the zipcode matches that of their personal information.
   * @param coachId
   * @param branchId
   * @param distance
   * @returns any Successful Response
   * @throws ApiError
   */
  public postFspSetCoachBranchDistanceVLatest(
    coachId: number,
    branchId: number,
    distance: number
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/fsp/fsp_coach/coach/{coach_id}/branch/{branch_id}/distance',
      path: {
        coach_id: coachId,
        branch_id: branchId,
      },
      query: {
        distance: distance,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Build Facturation Csv
   * ### Start constructing the facturation csv
   *
   * Get the facturation csv for the last week. This is all shifts that have been accorded in the previous week.
   *
   * Args:
   * - week (int): The week number of the week to get the facturation csv for, defaults to the previous week
   * - year (int): The year of the week to get the facturation csv for, defaults to the current year
   *
   * Important to note:
   * - The function is expected to be called only by people from the office, on monday around 9:00
   *
   * Returns:
   * - The csv with all shifts that have been accorded in the previous week, that have to be facturated from collaborations: "'Te factureren: samenwerkingspartners'"
   * @param week
   * @param year
   * @returns BaseTask Successful Response
   * @throws ApiError
   */
  public postFspBuildFacturationCsvVLatest(
    week: number = 10,
    year: number = 2025
  ): CancelablePromise<BaseTask> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/fsp/facturation/facturation/csv/collaborations/week',
      query: {
        week: week,
        year: year,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Build Facturation Csv Month
   * ### Start constructing the facturation csv
   *
   * Get the facturation csv for the last month. This is all shifts that have been accorded in the previous month.
   *
   * Args:
   * - month (int): The month number of the month to get the facturation csv for, defaults to the previous month
   * - year (int): The year of the month to get the facturation csv for, defaults to the current year
   *
   * Returns:
   * - The csv with all shifts that have been accorded in the previous month, that have to be facturated from coaches: "'Uit te betalen: Studyworkers'"
   * @param month
   * @param year
   * @returns BaseTask Successful Response
   * @throws ApiError
   */
  public postFspBuildFacturationCsvMonthVLatest(
    month: number = 2,
    year: number = 2025
  ): CancelablePromise<BaseTask> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/fsp/facturation/facturation/csv/coaches/month',
      query: {
        month: month,
        year: year,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Collaboration Facturation Csv String Task
   * ### Get facturation csv task
   *
   * This endpoint gets the task status of the facturation csv task. If the task is successful, it will return the csv as a response.
   *
   * This is used for both the weekly and monthly facturation csv tasks.
   * - Weekly: "'Te factureren: samenwerkingspartners'"
   * - Monthly: "'Uit te betalen: Studyworkers'"
   *
   * Args:
   * - task_id (str): The task id of the facturation csv task
   *
   * Returns:
   * - The task status of the facturation csv task
   * @param taskId
   * @returns any Successful Response
   * @throws ApiError
   */
  public getFspGetCollaborationFacturationCsvStringTaskVLatest(
    taskId: string
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/fsp/facturation/facturation/csv/task/{task_id}',
      path: {
        task_id: taskId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
